"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// Promise polyfill
require("core-js/features/promise");
const react_dom_1 = require("react-dom");
const react_router_dom_1 = require("react-router-dom");
const App_1 = __importDefault(require("./components/App"));
require("@amzn/awsui-global-styles/polaris.css");
document.addEventListener('DOMContentLoaded', () => {
    (0, react_dom_1.render)((0, jsx_runtime_1.jsx)(react_router_dom_1.HashRouter, { children: (0, jsx_runtime_1.jsx)(App_1.default, {}) }), document.querySelector('#app'));
});
